import * as React from "react";
// import MetaCardTable from './MetaCardTable';
import Container from '@mui/material/Container';
import MyWalletTable  from './MyWalletTable';

const MyWallet = (props) => { 

  return (
    <div className="App">
      {/* <Container maxWidth={false}>
        <h2 className="heading-title">Wallet</h2>
        <p style={{ fontSize: "0.95rem", color: "#4a4a4a", margin: 0 }}>
            View and download your Wallet Transactions
        </p>
      </Container> */}

      <Container maxWidth={false}>
        <MyWalletTable />
      </Container>
    </div>
  );
}
export default MyWallet;
